export const personalDataProcessingPolicy = 'https://images.as-souznmp.ru/personal-data-processing-policy.pdf';
